import React from 'react';
import './Styles.css'; // Assuming you'll create a CSS file for styling

function PrivacyPolicy() {
  return (
    <div className="policy-container">
      <h1>Privacy Policy</h1>
      <p>Last Updated: 1 Jan 2025</p>
      <p>Aura Voyages Private Limited respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website https://auravoyages.com/ or use our services related to travel in India.</p>

      <h2>1. Information We Collect</h2>
      <p>We may collect the following types of personal information:</p>
      <ul>
        <li>Personal Identifiers: Name, email address, phone number, nationality, passport details.</li>
        <li>Travel Information: Flight details, hotel preferences, dietary restrictions, special requests.</li>
        <li>Payment Details: Credit/debit card information, billing address (processed securely via third-party payment gateways).</li>
        <li>Technical Data: IP address, browser type, device information, cookies, and usage data.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>Your information is used to:</p>
      <ul>
        <li>Provide and manage travel bookings (including jungle safaris, flights, trains) and itineraries.</li>
        <li>Communicate with you regarding your travel plans, updates, and support.</li>
        <li>Customize your travel experiences in India.</li>
        <li>Process payments securely.</li>
        <li>Comply with legal and regulatory requirements.</li>
        <li>If you are travelling to Bhutan, your passport details are required to process the Bhutan Visa.</li>
        <li>Improve our Website, services, and customer experience.</li>
      </ul>

      <h2>3. Sharing of Information</h2>
      <p>We do not sell or rent your personal information. We may share your data with:</p>
      <ul>
        <li>Service Providers: Hotels, airlines, trains, transport providers, tour guides, jungle safari bookings, Visa processing and other local partners necessary to fulfill your booking.</li>
        <li>Payment Gateways: For secure transaction processing.</li>
        <li>Legal Authorities: If required by law, regulation, or court order.</li>
        <li>Business Transfers: In case of a merger, acquisition, or asset sale.</li>
      </ul>

      <h2>4. International Data Transfers</h2>
      <p>Since our clients are from outside India, your data may be transferred to and stored on servers outside your home country. We ensure that such transfers are conducted securely and in compliance with applicable data protection laws (e.g., GDPR).</p>

      <h2>5. Cookies & Tracking Technologies</h2>
      <p>Our Website uses cookies and similar technologies to enhance your browsing experience, analyse site traffic, and personalize content. You can control cookies through your browser settings, but disabling them may affect website functionality.</p>

      <h2>6. Data Security</h2>
      <p>We implement appropriate administrative, technical, and physical safeguards to protect your data. However, no method of transmission or storage is 100% secure, and we cannot guarantee absolute security.</p>

      <h2>7. Data Retention</h2>
      <p>We retain your personal data only as long as necessary to fulfill the purposes described in this Privacy Policy or as required by law.</p>

      <h2>8. Your Rights</h2>
      <p>Depending on your jurisdiction, you may have the right to:</p>
      <ul>
        <li>Access, update, or delete your personal data.</li>
        <li>Withdraw consent at any time.</li>
        <li>Object to processing or request data portability.</li>
        <li>File a complaint with your local data protection authority.</li>
      </ul>
      <p>To exercise your rights, please contact us at info@auravoyages.com</p>

      <h2>9. Third-Party Links</h2>
      <p>Our Website may contain links to third-party websites. We are not responsible for the privacy practices or content of such sites.</p>

      <h2>10. Children’s Privacy</h2>
      <p>Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children.</p>

      <h2>11. Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated “Last Updated” date.</p>

      <h2>12. Contact Us</h2>
      <p>If you have any questions or concerns regarding this Privacy Policy or how your data is handled, please contact us at:</p>
      <p>Aura Voyages Private Limited<br />Email: info@auravoayges.com <br />Phone: +91 98107 20202<br />Address: National Apartment, C-131, Sector 3, Plot No. 4, Dwarka, New Delhi - 110078</p>
    </div>
  );
}

export default PrivacyPolicy;